document.addEventListener('DOMContentLoaded', function () {
  var dropdowns = document.querySelectorAll('[data-toolbar-dropdown]');

  function closeDropdown(dropdown) {
    dropdown.classList.remove('is-open');
    var trigger = dropdown.querySelector('[data-dropdown-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAllDropdowns(except) {
    dropdowns.forEach(function (dropdown) {
      if (dropdown !== except) closeDropdown(dropdown);
    });
  }

  dropdowns.forEach(function (dropdown) {
    var trigger = dropdown.querySelector('[data-dropdown-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      var wasOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns(dropdown);
      if (wasOpen) {
        closeDropdown(dropdown);
      } else {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (event) {
    dropdowns.forEach(function (dropdown) {
      if (!dropdown.contains(event.target)) closeDropdown(dropdown);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllDropdowns();
  });

  document.querySelectorAll('[data-sort-panel]').forEach(function (panel) {
    var baseUrl = panel.getAttribute('data-sort-url') || window.location.pathname;

    panel.querySelectorAll('[data-sort-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        var url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('sort_by', option.getAttribute('data-sort-value'));
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  });

  document.querySelectorAll('[data-product-filters]').forEach(function (filterRoot) {
    var productGrid = filterRoot.closest('.product-grid');
    if (!productGrid) return;

    var grid = productGrid.querySelector('[data-product-grid]');
    var emptyState = productGrid.querySelector('[data-product-grid-empty]');
    if (!grid) return;

    var state = { durum: 'all', tip: 'all' };

    function applyFilters() {
      var cards = grid.querySelectorAll('[data-product-card]');
      var visibleCount = 0;

      cards.forEach(function (card) {
        var durum = card.getAttribute('data-durum') || '';
        var tip = card.getAttribute('data-tip') || '';

        var durumMatch = state.durum === 'all' || durum === state.durum;
        var tipMatch = state.tip === 'all' || tip === state.tip;

        var visible = durumMatch && tipMatch;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }
    }

    filterRoot.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var groupName = group.getAttribute('data-filter-group');

      group.querySelectorAll('.filter-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.filter-pill').forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
          state[groupName] = pill.getAttribute('data-filter-value');
          applyFilters();
        });
      });
    });
  });
});
